export default {
  getSection(state) {
    return state.section;
  }
};
